@if (generateAllBtn()) {
  <button type="button"
          (click)="getAllStatementsAndGeneratePdf()"
          class="c-button c-button--primary pdf btnIphone statementsFileDownload__mainBtn"
          [ngClass]="{ 'acc-overview-sp': showSection() === true }"
          [disabled]="loading()"
  >
    @if (loading()) {
      <cx-spinner class="statementsFileDownload__spinner"/>
    } @else {
      <img src="icons/pdf_icon_white.svg" alt="pdf" class="statementsFileDownload__pdfIcon mr-1">
      {{ 'statements.mainDownloadBtn' | cxTranslate }}
    }
  </button>
} @else if (onModalView()) {
  <div class="d-flex justify-content-center align-items-center statementsFileDownload__onModalView">
    @if (loading()) {
      <cx-spinner class="statementsFileDownload__spinner statementsFileDownload__spinner--row"/>
    } @else {
      <button (click)="getAllStatementsAndGeneratePdf()" id="printStatementLinkId" class="py-1 px-3 bg-white c-button c-button--secondary statementsFileDownload__modalViewBtn">
        <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>
        {{ "statementDisplay.print_text" | cxTranslate }}
      </button>
    }
  </div>
} @else {
  @if (loading()) {
    <cx-spinner class="statementsFileDownload__spinner statementsFileDownload__spinner--row"/>
  } @else {
    <button title="download PDF link" (click)="getAllStatementsAndGeneratePdf()" class="c-button c-button--link-primary text-decoration-none text-left">
      <img src="/icons/pdf_icon_primary.svg" class="statementsFileDownload__pdfIcon mr-1">
      {{ 'statements.statementList.pdf_text' | cxTranslate }}
    </button>
  }
}
